module.exports = __webpack_public_path__ + "img/J2.ad4087fb.png";